var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-193,-166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.548274,0,0,0.548274,88.4418,80.0141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.71,166.508C195.998,165.797 195.998,164.641 196.71,163.929C197.422,163.217 198.578,163.217 199.29,163.929L217.529,182.168C218.241,182.88 218.241,184.036 217.529,184.748C216.817,185.459 215.661,185.459 214.949,184.748L196.71,166.508Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.64019e-16,-0.548274,0.548274,7.64019e-16,106.415,289.157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.71,166.508C195.998,165.797 195.998,164.641 196.71,163.929C197.422,163.217 198.578,163.217 199.29,163.929L217.529,182.168C218.241,182.88 218.241,184.036 217.529,184.748C216.817,185.459 215.661,185.459 214.949,184.748L196.71,166.508Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.a93215d257a24d89c5468f5d8294a824.svg";
export { ForwardRef as ReactComponent };